module.exports = __webpack_public_path__ + "img/perforaciones_4-3_682.84d8d95a.webp";